import {
  Menu,
  MenuButton,
  Button,
  Flex,
  MenuList,
  MenuItem,
  Text,
  Box,
  Center,
  Icon,
} from "@chakra-ui/react";
import { BsCaretDownFill } from "react-icons/bs";

export const DropDown = ({
  selected,
  title,
  options,
  onOptionChange,
  fontSize = "14px",
  disabled = false,
}: {
  selected: { id: number; component: JSX.Element } | undefined;
  title: JSX.Element;
  options: { id: number; component: JSX.Element }[];
  onOptionChange: (id: number) => void;
  fontSize?: string;
  disabled?: boolean;
}) => {
  return (
    <Menu matchWidth>
      {title}
      <MenuButton
        as={Button}
        rightIcon={
          <Icon as={BsCaretDownFill as React.ElementType} boxSize="18px" color="white" />
        }
        borderWidth="1px"
        borderColor="rgba(255, 255, 255, 0.2)"
        backgroundColor={disabled ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.1)"}
        backdropFilter="blur(10px)"
        color="white"
        _hover={{
          backgroundColor: disabled ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.2)",
          borderColor: "rgba(118, 82, 247, 0.5)"
        }}
        _active={{
          backgroundColor: disabled ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.2)"
        }}
        cursor={disabled ? "default" : "pointer"}
        width="100%"
        p={4}
        borderRadius="12px"
      >
        <Flex align="center">
          <Box
            fontSize={`${fontSize}`}
            fontWeight="500"
            mr="2"
            maxWidth="calc(100%)"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {selected ? (
              selected.component
            ) : (
              <Text fontSize={`${fontSize}`} textColor="gray.500">
                Select an option
              </Text>
            )}
          </Box>
        </Flex>
      </MenuButton>
      <MenuList
        fontSize={`${fontSize}`}
        maxHeight="40vh"
        overflowY="auto"
        fontWeight="500"
        hidden={disabled}
        bg="rgba(0, 0, 0, 0.8)"
        backdropFilter="blur(20px)"
        borderColor="rgba(255, 255, 255, 0.2)"
        borderRadius="12px"
        color="white"
      >
        {options.map((option) => (
          <MenuItem
            _hover={{ backgroundColor: "rgba(118, 82, 247, 0.3)" }}
            cursor={disabled ? "default" : "pointer"}
            onClick={() => {
              if (!disabled) onOptionChange(option.id);
            }}
            key={option.id}
            color="white"
            bg="transparent"
          >
            {option.component}
          </MenuItem>
        ))}
        {options.length === 0 && (
          <Center>
            <Text fontSize="16px" textColor="gray.500" my={2}>
              No options available
            </Text>
          </Center>
        )}
      </MenuList>
    </Menu>
  );
};
